export default __webpack_public_path__ + "static/media/logo-actguide-negative.67622b0a.png";